/*
 * Theme preference — light | dark | system, persisted to localStorage 'gw-theme'.
 *
 * The PREFERENCE can be 'system' (follow the OS/browser via prefers-color-scheme);
 * the APPLIED theme (document.documentElement.dataset.theme) is always 'light' | 'dark'.
 * initThemeWatcher() keeps 'system' live: when the OS flips light↔dark, it re-applies —
 * but only while the saved preference is still 'system'. Boot (index.js) and the Display
 * toggle both go through here so there's one source of truth.
 */
const KEY = 'gw-theme';
const prefersDark = () => {
  try { return window.matchMedia('(prefers-color-scheme: dark)'); }
  catch (e) { return { matches: false, addEventListener: null, addListener: null }; }
};

export function getThemePref() {
  try {
    const s = window.localStorage.getItem(KEY);
    return (s === 'dark' || s === 'light' || s === 'system') ? s : 'light';
  } catch (e) { return 'light'; }
}

// resolve a preference to the concrete palette to paint
export function resolveTheme(pref) {
  const p = pref || getThemePref();
  if (p === 'system') return prefersDark().matches ? 'dark' : 'light';
  return p === 'dark' ? 'dark' : 'light';
}

export function applyTheme(pref) {
  document.documentElement.dataset.theme = resolveTheme(pref);
}

export function setThemePref(pref) {
  try { window.localStorage.setItem(KEY, pref); } catch (e) { /* ignore */ }
  applyTheme(pref);
}

// re-apply on OS light/dark change while the user is on 'system'
export function initThemeWatcher() {
  const mq = prefersDark();
  const onChange = () => { if (getThemePref() === 'system') applyTheme('system'); };
  if (mq.addEventListener) mq.addEventListener('change', onChange);
  else if (mq.addListener) mq.addListener(onChange); // Safari < 14
}
